mutation NoteUserProfileCreate($input: NoteUserProfileCreateInput!) {
  noteUserProfileCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}